exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "* {\n    box-sizing: border-box;\n    line-height: 1.2;\n}\n\nbody {\n    font-family: 'Danzza';\n    font-weight: 300;\n    font-size: 1rem;\n    color: #000;\n}\n\na {\n    color: #808080;\n    transition: color 0.25s;\n}\n\na:hover,\na:active {\n    color: #000;\n}\n\np {\n    line-height: 1.4;\n}\n", ""]);

// exports
